module.exports = __webpack_public_path__ + "static/media/zoomexample.912b3103.png";